import React, { Component } from "react";
import { Loader } from "react-loaders";
import _, { isNil } from "lodash";
import NumberFormat from "react-number-format";

import UiTitle from "../components/finance/decisions/ui-title";
import Auth from "../routes/Auth";
import { batchRequest, getRequest } from "../api/ApiService";
import { logError, detectMobile } from "../services/utils";
import HelpIconButtonWithTooltipAndTypeformModal from "../components/typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../components/typeform/TypeformContent";
import Chart from "../components/finance/decisions/chart";
import CashBalanceButton from "../components/finance/decisions/cash-balance-button";
import CashBalanceModal from "../components/finance/decisions/cash-balance-modal";
import EventEmitter from "../services/event-emitter";
import RaiseCapitalButton from "../components/finance/decisions/raise-capital-button";
import RaiseCapitalSelectModal from "../components/finance/decisions/raise-capital-select-modal";
import RaiseEquityModal from "../components/finance/decisions/raise-equity-modal";
import RaiseDebtModal from "../components/finance/decisions/raise-debt-modal";
import ReturnCapitalButton from "../components/finance/decisions/return-capital-button";
import ReturnCapitalSelectModal from "../components/finance/decisions/return-capital-select-modal";
import ReturnDebtModal from "../components/finance/decisions/return-debt-modal";
import ReturnEquityModal from "../components/finance/decisions/return-equity-modal";
import WarningAlert from "../components/alerts/warning";
import Fragment from 'react-dot-fragment';
import { Modal } from "react-bootstrap";

import {
  getSubmissionRequest,
  handleSubmission,
  submitDecisions,
  updateSubmissionFromJournal
} from "../api/SubmitDecisions";
import Styled from "components/finance/style";
import ArrowSvg from "components/pm/arrow.svg";
import { view } from "@risingstack/react-easy-state";
import SweetAlert from "sweetalert-react";
import LastStepModal from "../components/get-started/last-step";
import { moneyFormat } from '../components/analysis/format';

import IconTableHelp from "./assets/icon-table-help.svg";

import CapitalStructureVideo from './assets/finance-capital-structure.mp4';
import LendingRateVideo from './assets/finance-lending-rate.mp4';
import DebtToCapitalVideo from './assets/finance-debt-to-capital.mp4';
import InterestChargedVideo from './assets/finance-interest-charged.mp4';


const FINANCE_DECISIONS_URL = `${process.env.REACT_APP_API_URL}team/page/financials/`;

const videos = {
  'Capital Structure': CapitalStructureVideo,
  'Lending Rate': LendingRateVideo,
  'Debt to Capital': DebtToCapitalVideo,
  'Interest Charged': InterestChargedVideo,
};

class FinanceDecisions extends Component {
  constructor(props) {
    super(props);

    const role = Auth.getRole();
    const hasAccess = role === "CEO" || role === "FI";
    const isOwnRole = role === "FI";

    this.state = {
      isOwnRole,
      hasAccess,
      submitDecisionsLoading: true,
      submission_data: {
        fn: {
          date: "N/A",
          unaccepted: 0
        }
      },
      projections_submitted: false,
      debt_to_capital: 0,
      cost_to_capital: 0,
      lending_rate: 0,
      loans: [],
      equity_cumulative: 0,
      equity: 0,
      ending_cash: 0,
      prev_cash_balance: 0,
      financial_decisions: null,
      loading: true,
      roundInUrl: props.roundInUrl,
      currentRound: props.currentRound,
      rounds: props.rounds,
      unaccepted_decisions: {
        FI: 0,
        PM: 0,
        PD: 0,
        OP: 0
      },
      showNoProjectionsModal: false,
      isPreChecked: false,
      interest_charge: 0,
      product_n_marketing: 0,
      operations: 0,
      net_cash_balance_from_finance: 0,
      showWarningModal: false,
      warningTitle: '',
      warningMessage: '',
      warningButtonText: '',
      isVideoModalShown: false,
      isVideoPlaying: false,
      selectedVideo: null
    };

    this.eventemitter = EventEmitter.getInstance();
    this.isMobile = detectMobile();

    this.videoRef = null;
  }

  handlePlayPause = () => {
    if (this.videoRef) {
      if (this.state.isVideoPlaying) {
        this.videoRef.pause();
      } else {
        this.videoRef.play();
      }
      this.setState({ isVideoPlaying: !this.state.isVideoPlaying });
    }
  };

  openVideoModal = (videoSrc) => {
    this.setState({
      isVideoModalShown: true,
      selectedVideo: videoSrc,
    });
  };

  closeVideoModal = () => {
    this.setState({
      isVideoModalShown: false,
      isVideoPlaying: false
    });
  };

  onHelpIconClick = (field) => {
    if (videos[field]) {
      this.openVideoModal(videos[field]);
    }
  };

  hideNoProjectionsModal = () => {
    this.setState({
      showNoProjectionsModal: false
    });
  };

  reloadRole = () => {
    const role = Auth.getRole();
    const hasAccess = role === "CEO" || role === "FI";
    const isOwnRole = role === "FI";

    this.setState({
      hasAccess,
      isOwnRole
    });
  };

  componentDidMount() {
    this.eventemitter.on("update-submit-decisions", this.updateSubmitDecisions);
    this.fetchData();
  }

  componentWillUnmount() {
    this.eventemitter.off("update-submit-decisions", this.updateSubmitDecisions);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.roundInUrl !== nextProps.roundInUrl ||
      this.state.currentRound !== nextProps.currentRound ||
      (this.state.rounds.length === 0 && nextProps.rounds.length > 0)
    ) {
      this.setState(
        {
          currentRound: nextProps.currentRound,
          roundInUrl: nextProps.roundInUrl,
          rounds: nextProps.rounds
        },
        () => {
          this.fetchData();
          this.reloadRole();
        }
      );
    }
  }

  updateSubmitDecisions = () => {
    const { roundInUrl, currentRound } = this.state;

    updateSubmissionFromJournal(
      ['fn'],
      roundInUrl !== null ? roundInUrl : currentRound,
      submission_data => {
        this.setState({
          submission_data,
        });
      }
    );
  }

  get roundNumber() {
    const { currentRound, roundInUrl } = this.state;

    let round_number = currentRound;
    if (roundInUrl !== null && roundInUrl !== currentRound) {
      round_number = roundInUrl;
    }

    return round_number;
  }

  fetchData = () => {
    const { rounds } = this.state;

    if (rounds.length === 0) {
      return;
    }

    const round_number = this.roundNumber;
    const temporaryUser = Auth.getTemporaryUser();
    const additionalQuery = temporaryUser ? `&team_id=${temporaryUser.team_id}` : "";

    batchRequest([
      FINANCE_DECISIONS_URL + `?round_number=${round_number}${additionalQuery}`,
      ...getSubmissionRequest(
        ["fn"],
        round_number,
        false,
        temporaryUser,
      ),
      `${process.env.REACT_APP_API_URL}games/${Auth.getGameId()}/journal/?round_number=${round_number}${temporaryUser ? `&team_id=${temporaryUser.team_id}` : ''}`,
      `${process.env.REACT_APP_API_URL}team/debts/?round_number=${round_number}${temporaryUser ? `&team_id=${temporaryUser.team_id}` : ''}`
    ])
      .then(res => {
        if (
          res[0].statusCode !== 200 ||
          res[1].statusCode !== 200
        ) {
          throw res;
        }

        const decisions = res[0].body;
        const unaccepted_decisions = res[1].body;
        const submission_data = handleSubmission(
          ["fn"],
          [unaccepted_decisions, res[2].body]
        );

        const {
          projections_submitted,
          debt_to_capital,
          cost_to_capital,
          loans,
          equity_cumulative,
          equity,
          ending_cash,
          prev_cash,
          product_n_marketing,
          operations,
          net_cash_balance_from_finance,
        } = decisions.team;

        const journal = res[3].body;
        const pathFound1 = journal.filter(i => i.path.indexOf('/api/team/equities/') === 0).length > 0;
        const pathFound2 = journal.filter(i => i.path.indexOf('/api/team/debts/') === 0).length > 0;
        const pathFound3 = journal.filter(i => i.path.indexOf('/api/team/debt_repayments/') === 0).length > 0;
        const pathFound4 = journal.filter(i => i.path.indexOf('/api/team/dividends_payment/') === 0).length > 0;
        const pathFound5 = journal.filter(i => i.path.indexOf('/api/team/stock_repurchased/') === 0).length > 0;
        const isPreChecked = pathFound1 || pathFound2 || pathFound3 || pathFound4 || pathFound5;

        const teamDebts = res[4].body;

        const { teamInterestCharge, teamBalance } = teamDebts.reduce((acc, item) => {
          acc.teamInterestCharge += item.interest_charge;
          acc.teamBalance += item.balance;
          return acc;
        }, { teamInterestCharge: 0, teamBalance: 0 });

        const lending_rate = teamBalance ? teamInterestCharge / teamBalance : 0;

        this.setState({
          projections_submitted,
          debt_to_capital,
          cost_to_capital,
          loans,
          equity_cumulative,
          equity,
          ending_cash,
          financial_decisions: decisions,
          prev_cash_balance: prev_cash,
          submission_data,
          submitDecisionsLoading: false,
          loading: false,
          unaccepted_decisions,
          isPreChecked,
          lending_rate,
          interest_charge: teamInterestCharge,
          product_n_marketing,
          operations,
          net_cash_balance_from_finance,
        });
      })
      .catch(err => {
        logError(err, "FinanceDecisions", "fetchData");
      });
  };

  submitDecisions = () => {
    this.setState({
      submitDecisionsLoading: true
    });

    const { currentRound } = this.props;

    getRequest(`${process.env.REACT_APP_API_URL}team/page/financials/?round_number=${currentRound}`)
      .then(res => {
        const teamPageFinancials = res.body;
        const teamData = teamPageFinancials.team ? teamPageFinancials.team : null;
        const endingCash = teamData.ending_cash ? teamData.ending_cash : null;

        if (endingCash && endingCash < 0) {
          this.setState({
            showWarningModal: true,
            warningTitle: 'Warning! You Need More Cash',
            warningMessage: <Fragment>
              <p>Your finance decisions were successfully posted, but you still have insufficient capital.</p><br />
              <p>In order for your decisions to be fully accepted, your cash balance on the finance decision page needs to have a positive value. </p></Fragment>,
            warningButtonText: 'Done'
          });
        } else {
          submitDecisions("finance", this.state.roundInUrl || this.state.currentRound, () => {
            this.fetchData();
          });
        }
      })
      .catch(err => { });
  };

  get showActionButtons() {
    const { currentRound, roundInUrl, rounds, hasAccess } = this.state;
    const { roundShouldBeFinished } = this.props;

    if (
      hasAccess === false ||
      roundShouldBeFinished === true ||
      (roundInUrl !== null && roundInUrl !== currentRound)
    ) {
      return false;
    }

    const round = rounds.find(i => i.number === currentRound);
    if (!round) {
      return false;
    }

    return round.is_started === true && round.is_finished === false;
  }

  get debtToCapital() {
    const { debt_to_capital } = this.state;

    return debt_to_capital > 0 ? (debt_to_capital * 100).toFixed(2) : "";
  }

  get costOfCapital() {
    const { cost_to_capital } = this.state;

    return cost_to_capital > 0 ? (cost_to_capital * 100).toFixed(2) : "";
  }

  get interestCharge() {
    const { interest_charge } = this.state;

    return interest_charge > 0 ? moneyFormat(Math.abs(interest_charge)) : "";
  }

  get lendingRate() {
    const { lending_rate } = this.state;

    return lending_rate > 0 ? (lending_rate * 100).toFixed(2) : "";
  }

  get cashBalance() {
    const { ending_cash } = this.state;

    return ending_cash.toFixed(0);
  }

  showCashBalanceModal = () => {
    this.eventemitter.trigger("show-cash-balance-modal");
  };

  showRaiseCapitalSelectModal = () => {
    const { projections_submitted } = this.state;

    if (!projections_submitted) {
      this.setState({
        showNoProjectionsModal: true
      });
    } else {
      this.eventemitter.trigger("show-raise-capital-select-modal");
    }
  };

  showRaiseDebtModal = () => {
    this.eventemitter.trigger("hide-raise-capital-select-modal");
    this.eventemitter.trigger("show-raise-debt-modal");
  };

  showRaiseEquityModal = () => {
    this.eventemitter.trigger("hide-raise-capital-select-modal");
    this.eventemitter.trigger("show-raise-equity-modal");
  };

  showReturnCapitalSelectModal = () => {
    this.eventemitter.trigger("show-return-capital-select-modal");
  };

  showReturnDebtModal = () => {
    this.eventemitter.trigger("hide-return-capital-select-modal");
    this.eventemitter.trigger("show-return-debt-modal");
  };

  showReturnEquityModal = () => {
    this.eventemitter.trigger("hide-return-capital-select-modal");
    this.eventemitter.trigger("show-return-equity-modal");
  };

  get showGraph() {
    const { loans, equity_cumulative } = this.state;
    const debts = _.sumBy(loans, "amount");

    return debts > 0 || equity_cumulative > 0;
  }

  showInterestChargeWarning = () => {
    this.setState({
      showWarningModal: true,
      warningMessage: <Fragment>
        <b>Warning! Your Overall Interest Charged is High!</b> High interest expense could have an adverse impact in your Round 3 performance.
        Consider reducing your outstanding loans or at at the minimum, paying down your interest payable.
      </Fragment>,
      warningButtonText: 'Ok'
    });
  }
  hideWarningModal = () => {
    this.setState({
      showWarningModal: false,
    });
  }

  render() {
    const {
      isOwnRole,
      submitDecisionsLoading,
      submission_data,
      loading,
      loans,
      equity_cumulative,
      ending_cash,
      prev_cash_balance,
      currentRound,
      rounds,
      roundInUrl,
      financial_decisions,
      unaccepted_decisions,
      showNoProjectionsModal,
      isPreChecked,
      product_n_marketing,
      operations,
      net_cash_balance_from_finance,
      showWarningModal,
      warningTitle,
      warningMessage,
      warningButtonText,
      isVideoModalShown,
      isVideoPlaying
    } = this.state;
    const { location, router, currentRound: roundFromProps } = this.props;

    const hasAccess = this.showActionButtons;
    const roundNumber = this.roundNumber;
    const cashBalance = this.cashBalance;
    const round = isNil(roundInUrl) ? currentRound : roundInUrl;
    const roundId = rounds.find(i => i.number === Number(round)).id;

    return (
      <Styled.BodyWrapper>
        <LastStepModal
          location={location}
          router={router}
          url={`/decisions/finance?round=${roundFromProps}`}
        />
        <UiTitle
          isOwnRole={isOwnRole}
          hasAccess={hasAccess}
          submitDecisionsLoading={submitDecisionsLoading}
          submitDecisionsData={submission_data.fn}
          submitDecisions={this.submitDecisions}
          loading={loading}
          financial_decisions={financial_decisions}
          unaccepted_decisions={unaccepted_decisions}
          isPreChecked={isPreChecked}
        />
        <SweetAlert
          show={showNoProjectionsModal}
          title="Warning"
          text="Your CEO needs to make financial projections before you will be able to raise any capital. Please coordinate with your CEO."
          type="warning"
          onConfirm={this.hideNoProjectionsModal}
        />
        {loading === false && (
          <div>
            {hasAccess === true && (
              <Styled.ButtonsWrapper>
                <div className="row pm-decisions-buttons">
                  <Styled.ButtonsWrapperFlex className="col-md-12 col-xs-12">
                    <RaiseCapitalButton
                      onClick={this.showRaiseCapitalSelectModal}
                    />
                    <RaiseCapitalSelectModal
                      onDebt={this.showRaiseDebtModal}
                      onEquity={this.showRaiseEquityModal}
                    />
                    <RaiseDebtModal
                      equity={equity_cumulative}
                      roundNumber={roundNumber}
                      reloadData={this.fetchData}
                      showInterestChargeWarning={this.showInterestChargeWarning}
                    />
                    <RaiseEquityModal
                      roundNumber={roundNumber}
                      currentRound={currentRound}
                      rounds={rounds}
                      reloadData={this.fetchData}
                    />
                    <Styled.Arrow>
                      <img src={ArrowSvg} alt="" />
                    </Styled.Arrow>
                    <ReturnCapitalButton
                      onClick={this.showReturnCapitalSelectModal}
                    />
                    <ReturnCapitalSelectModal
                      onDebt={this.showReturnDebtModal}
                      onEquity={this.showReturnEquityModal}
                      equityEnabled={round >= 2}
                    />
                    <ReturnDebtModal
                      roundNumber={roundNumber}
                      cashBalance={cashBalance}
                      reloadData={this.fetchData}
                      roundId={roundId}
                    />
                    <ReturnEquityModal
                      roundNumber={roundNumber}
                      cashBalance={cashBalance}
                      reloadData={this.fetchData}
                    />
                  </Styled.ButtonsWrapperFlex>
                </div>
              </Styled.ButtonsWrapper>
            )}
            <Styled.CashBalanceRow>
              <Styled.CashBalanceTitle>Cash Balance</Styled.CashBalanceTitle>
              <CashBalanceButton onClick={this.showCashBalanceModal}>
                <NumberFormat
                  value={cashBalance}
                  displayType="text"
                  prefix="$"
                  thousandSeparator=","
                />
              </CashBalanceButton>
              <CashBalanceModal
                beginningCash={prev_cash_balance}
                ProductNMarketing={product_n_marketing}
                operations={operations}
                financing={net_cash_balance_from_finance}
                cashBalance={ending_cash}
              />
            </Styled.CashBalanceRow>
          </div>
        )}
        {loading === true && <Loader type="ball-scale-ripple" active />}
        {loading === false && (
          <Styled.WhiteBlock>
            <Styled.Title1>Total Capital</Styled.Title1>
            <Styled.Title2>
              Capital Structure
              <Styled.HelpIcon src={IconTableHelp} onClick={() => this.onHelpIconClick("Capital Structure")} />
            </Styled.Title2>
            {this.showGraph === true && (
              <Chart loans={loans} equity={equity_cumulative} />
            )}
            <Styled.AmountsRow>
              <Styled.AmountsColumn1>
                <Styled.Title3>
                  Lending Rate
                  <Styled.HelpIcon src={IconTableHelp} onClick={() => this.onHelpIconClick("Lending Rate")} />
                </Styled.Title3>
                <Styled.Amount shown={true}>
                  {this.lendingRate}%
                </Styled.Amount>
              </Styled.AmountsColumn1>
              <Styled.AmountsColumn2>
                <Styled.Title3>
                  Debt to Capital
                  <Styled.HelpIcon src={IconTableHelp} onClick={() => this.onHelpIconClick("Debt to Capital")} />
                </Styled.Title3>
                <Styled.Amount shown={true}>
                  {this.debtToCapital}%
                </Styled.Amount>
              </Styled.AmountsColumn2>
              <Styled.AmountsColumn2>
                <Styled.Title3>
                  Interest Charged
                  <Styled.HelpIcon src={IconTableHelp} onClick={() => this.onHelpIconClick("Interest Charged")} />
                </Styled.Title3>
                <Styled.Amount shown={true} negative>
                  -{this.interestCharge}
                </Styled.Amount>
              </Styled.AmountsColumn2>
              {roundNumber >= 5 && (
                <Styled.AmountsColumn2>
                  <Styled.Title4>
                    Cost of Capital
                    <HelpIconButtonWithTooltipAndTypeformModal
                      iconSize="xs"
                      {...TypeformContent.COST_OF_CAPITAL}
                    />
                  </Styled.Title4>
                  <Styled.Amount shown={true}>
                    {this.costOfCapital}%
                  </Styled.Amount>
                </Styled.AmountsColumn2>
              )}
            </Styled.AmountsRow>
          </Styled.WhiteBlock>
        )}

        {showWarningModal && <WarningAlert
          title={warningTitle}
          message={warningMessage}
          onSuccess={this.hideWarningModal}
          onCancel={this.hideWarningModal}
          successButtonText={warningButtonText}
          showCancel={false}
        />}

        <Modal show={isVideoModalShown} onHide={this.closeVideoModal} className="goals-and-targets-modal">
          <Modal.Body>
            <Styled.ModalVideoWrapper className={isVideoPlaying ? 'is-playing' : ''}>
              <video
                ref={(ref) => { this.videoRef = ref; }}
                src={this.state.selectedVideo}
                alt="Welcome Video"
                onClick={this.handlePlayPause}
                onEnded={() => this.setState({ isVideoPlaying: false })}
                style={{ width: '100%', borderRadius: 10 }}
              />
              <Styled.PlayPauseButton onClick={this.handlePlayPause}>
                {isVideoPlaying ? '❚❚' : '▶'}
              </Styled.PlayPauseButton>
              <Styled.CloseModalVideoButton onClick={this.closeVideoModal}>×</Styled.CloseModalVideoButton>
            </Styled.ModalVideoWrapper>
          </Modal.Body>
        </Modal>
      </Styled.BodyWrapper>
    );
  }
}

export default view(FinanceDecisions);



// WEBPACK FOOTER //
// ./src/containers/finance-decisions.js